import Admin from './services';

export default Admin;
